import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Tag } from "../../Tag/Tag";
import { Spacer } from "../../Spacer";
import { colors } from "../../../../styles/figmaColors";
import Car from "../../../assets/Car.png";
import "../../../../../i18n/i18n";

export type TableVehicleAnalyticDetailsRow = {
  reference: string | null;
  registrationNumber: string | null;
  connectionType: "TELEMATICS" | "DEVICE";
};

export const useTableVehicleAnalyticDetailsRow = () => {
  const { t } = useTranslation();

  const render =
    (row: TableVehicleAnalyticDetailsRow) =>
    (key: keyof TableVehicleAnalyticDetailsRow) => {
      switch (key) {
        case "reference":
          return (
            <StyledReference>
              <StyledCar>
                <StyledCarImage src={Car} alt="Car" />
              </StyledCar>
              <Spacer x={1} />
              {row[key] && (
                <Tag
                  textColor={colors["colors/text/black"]}
                  backgroundColor={
                    colors["colors/surfaces/background/background_level0"]
                  }
                  text={row[key]}
                  borderColor={colors["colors/borders/cells/cells"]}
                />
              )}
            </StyledReference>
          );
        case "registrationNumber":
          return row.registrationNumber ?? "-";
        case "connectionType":
          return (
            <StyledConnectionType>
              <Tag
                textColor={colors["colors/text/darkGrey"]}
                text={t(`vehicles.connectionType.${row.connectionType}`)}
                backgroundColor={
                  colors["colors/surfaces/background/background_level1"]
                }
              />
            </StyledConnectionType>
          );
      }
    };

  const headers = {
    reference: {
      text: t("vehicles.table.analyticsDetailsRows.reference"),
    },
    registrationNumber: {
      text: t("vehicles.table.analyticsDetailsRows.registrationNumber"),
    },
    connectionType: {
      text: t("vehicles.table.analyticsDetailsRows.connectionType"),
    },
  };

  return { render, headers };
};

const StyledReference = styled.div`
  display: flex;
  align-items: center;
`;

const StyledCar = styled.div`
  display: flex;
  width: 2rem;
`;

const StyledCarImage = styled.img`
  width: 100%;
  filter: grayscale(100%);
`;

const StyledConnectionType = styled.div`
  display: flex;
  justify-content: flex-end;
`;
